import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsXboxComponent } from './simple-icons-xbox.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsXboxComponent ],
    exports:      [ SimpleIconsXboxComponent ],
    bootstrap:    []
})
export class SimpleIconsXboxModule {}
